import userDropdown from './user-dropdown.js'
import nav from './nav.js'
import news from './news.js'

export default {
  userDropdown,
  nav,
  news
}
